<div
  class="measurement-row flex items-center gap-3 px-3 py-2.5 cursor-pointer transition-colors hover:bg-surface-50 dark:hover:bg-surface-800 border-surface-200 dark:border-surface-700"
  [class.border-b]="!isLast()"
  [class.bg-primary-50]="selected()"
  [class.dark:bg-primary-950]="selected()"
  [class.rounded-t-xl]="selected() && isFirst()"
  [class.rounded-b-xl]="selected() && isAbsoluteLast()"
  (click)="onClick()"
  (dblclick)="onDoubleClick()"
>
  <i class="fa-solid fa-chart-line text-surface-400 shrink-0"></i>

  <div class="min-w-0 flex-1">
    <div class="font-medium truncate">{{ measurement().name }}</div>
    <div class="text-xs text-surface-500 truncate">
      {{ 'measurement.types.' + measurement().measurementType | translate }}
    </div>
  </div>

  <div class="flex items-center gap-2 shrink-0">
    <p-tag
      [severity]="statusSeverity()"
      [value]="('measurement.status.' + status()) | translate"
    ></p-tag>
    @if (showLiveness()) {
      <cosmos-measurement-liveness-badge
        [measurementType]="measurementType()"
        [lastTimestamp]="lastTimestamp()"
      ></cosmos-measurement-liveness-badge>
    }
  </div>

  @if (primaryValue() !== null && displayConfig(); as config) {
    <div class="hidden sm:flex flex-col items-end shrink-0 min-w-[5rem]">
      <span class="font-semibold">{{ primaryValue() | number:'1.0-2' }} {{ config.primaryUnit }}</span>
      <span class="text-xs text-surface-500">{{ config.primaryLabel | translate }}</span>
    </div>
  }

  @if (deviceName()) {
    <div class="hidden md:flex flex-col items-end shrink-0 min-w-[6rem]">
      <span class="text-sm truncate max-w-[8rem]">{{ deviceName() }}</span>
      <span class="text-xs text-surface-500">{{ 'measurement.card.device' | translate }}</span>
    </div>
  }

  <div class="hidden lg:flex flex-col items-end shrink-0 min-w-[8rem]">
    <span class="text-sm">
      {{ lastTimestamp() ? (lastTimestamp() | date:'dd/MM/yyyy HH:mm') : 'N/A' }}
    </span>
    <span class="text-xs text-surface-500">{{ 'cards.measurement.updated' | translate }}</span>
  </div>
</div>
